/** Label of the key that opens a link on click while editing: Cmd on macOS, Ctrl elsewhere */
export function modifierKeyLabel(): string {
  const platform = typeof navigator === 'undefined' ? '' : navigator.platform || ''
  return /mac|iphone|ipad/i.test(platform) ? '⌘' : 'Ctrl'
}
